import { Component, OnInit, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { PermissionDialogComponent } from 'path-shared/components/permission-dialog/permission-dialog.component';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { Builder } from 'path-shared/models/builder';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { NotificationService } from 'path-shared/services/notification/notification.service';
import { SiglasFilter } from '../../models/siglas-filter';
import { SiglasTableComponent } from '../../components/siglas-table/siglas-table.component';
import { SiglasEditorComponent } from '../../components/siglas-editor/siglas-editor.component';
import { SiglasFilterComponent } from '../../components/siglas-filter/siglas-filter.component';

@Component({
  selector: 'app-siglas',
  templateUrl: './siglas.component.html',
  styleUrls: ['./siglas.component.scss']
})
export class SiglasComponent implements OnInit, AfterViewInit {

  permissionDialogRef: MatDialogRef<PermissionDialogComponent>;
  activeFilters: string[] = [];
  filterData: SiglasFilter;
  somIdFoo: number;
  dataDialog: ComponentDialog = Builder.newComponentDialog();

  @ViewChild(SiglasTableComponent) siglasTable: SiglasTableComponent;

  constructor(
    private dialog: MatDialog,
    public auth: AuthorizationService,
    private i18n: I18n,
    private not: NotificationService,
    public thisDialogRef: MatDialogRef<SiglasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.filterData = new SiglasFilter('id', 'desc');
      if (data !== undefined) {
        this.dataDialog = data;
      }
    }

  ngOnInit(): void {
    this.auth.UserCanSeePage(this.auth.Pages.Siglas);
    this.siglasTable.itemClicked.subscribe(secure_id => {
      this.update(secure_id);
    });
    this.siglasTable.itemSelected.subscribe(codi => {
      this.thisDialogRef.close(codi);
    });
  }

  ngAfterViewInit() {
    if (!this.dataDialog.isDialog) {
      this.not.titleChange(this.i18n('Sigles'));
    }
  }

  edit() {
    const idSeleccionat: string = this.siglasTable.displayedItems['checkedItems'][0];
    this.update(idSeleccionat);
  }

  create() {
    this.update(null);
  }

  update(secure_id: string) {
    const data: ComponentDialog = Builder.newComponentDialog(true, false, secure_id);

    const ref = this.dialog.open(SiglasEditorComponent, {
      width: '30%',
      closeOnNavigation: false,
      autoFocus: true,
      data: data
    });

    ref.afterClosed().subscribe(updated => {
      if (updated) { this.siglasTable.load(); }
    });
  }

  refresh() {
    this.siglasTable.load();
  }

  onFilterClicked() {
    const ref = this.dialog.open(SiglasFilterComponent, {
      width: '50%',
      closeOnNavigation: false,
      autoFocus: true,
      data: {
        'filter': this.siglasTable.filter
      }
    });

    ref.componentInstance.notify.subscribe((filter: SiglasFilter) => {
      this.siglasTable.filter.set(filter);
      this.siglasTable.load();
    });
  }

  onRowSelected(somid) {
    this.update(somid);
  }

  generateExcel() {
    this.siglasTable.generateExcel();
  }

}
